export const SC3_V3_TO_V2_P1_PROMPT_MAP = Object.freeze({
  "symptom-checker-v3-ddx": "symptom-checker-v2-ddx",
  "symptom-checker-v3-ddx-standalone": "symptom-checker-v2-ddx-standalone",
  "symptom-checker-v3-ddx-phase3": "symptom-checker-v2-ddx-phase3",
  "symptom-checker-v3-ddx-standalone-phase3": "symptom-checker-v2-ddx-standalone-phase3",
});

const V2_TO_SC3_V3_P1_PROMPT_MAP = Object.freeze(
  Object.entries(SC3_V3_TO_V2_P1_PROMPT_MAP).reduce((acc, [sc3QueryId, v2PromptDocId]) => {
    if (!acc[v2PromptDocId]) {
      acc[v2PromptDocId] = [];
    }
    acc[v2PromptDocId].push(sc3QueryId);
    return acc;
  }, {})
);

export function getV2P1PromptDocIdForSc3V3QueryId(queryId) {
  if (!queryId) return null;
  return SC3_V3_TO_V2_P1_PROMPT_MAP[String(queryId)] || null;
}

export function getSc3V3QueryIdsForV2P1PromptDocId(promptDocId) {
  if (!promptDocId) return [];
  return V2_TO_SC3_V3_P1_PROMPT_MAP[String(promptDocId)] || [];
}
